export const CategoryBreakdown = ({ data, meta }) => {
  if (!data || !meta) return null;
  const entries = Object.entries(data.categories);
  const max = Math.max(1, ...entries.map(([, v]) => v));
  const group = (pol) => entries.filter(([k]) => meta[k].polarity === pol);
  const Row = ([k, v], color) => (
    <div key={k} className="grid grid-cols-[1fr_auto] items-center gap-x-3 gap-y-1">
      <span className="text-sm text-slate-700">{meta[k].label}</span>
      <span className="font-mono text-xs text-slate-500">{v}</span>
      <div className="col-span-2 h-1.5 rounded-full bg-slate-100">
        <div className={`h-1.5 rounded-full ${color}`} style={{ width: `${(v / max) * 100}%` }} />
      </div>
    </div>
  );
  return (
    <div className="grid gap-8 sm:grid-cols-2" data-testid="category-breakdown">
      <div className="space-y-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-emerald-800">Lifting the score</p>
        {group(1).map((e) => Row(e, "bg-emerald-400"))}
      </div>
      <div className="space-y-3">
        <p className="text-xs font-semibold uppercase tracking-widest text-rose-700">Weighing it down</p>
        {group(-1).map((e) => Row(e, "bg-rose-300"))}
      </div>
    </div>
  );
};
